export default [
  {
    component: () => import('../pages/insights-page.vue'),
    name: 'insights',
    path: '/:slug/insights',
  },
]
